/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365 from '@msdyn365-commerce/core';
import { IHeiLocaleRedirectViewProps } from './hei-locale-redirect';

export default (props: IHeiLocaleRedirectViewProps) => {
    let targetUrl = '';

    if (!MsDyn365.isBrowser) {
        return null;
    }

    const sitePath = props.context.request.sitePath;
    if (sitePath && (window.location.pathname ?? '').toLocaleLowerCase().startsWith(sitePath.toLocaleLowerCase())) {
        targetUrl = window.location.pathname.substring(sitePath.length) + window.location.search + window.location.hash;

        window.location.replace(targetUrl || '/');
    }

    return null;
};
